/**
 * O results.json que o almirante (modo tse) escreve em election-data.observador.pt.
 * Já vem validado, mas valida-se outra vez: um banner que mantém os últimos números
 * bons é melhor do que um que mostra NaN% na homepage.
 */
export interface CandidateResult {
    number: number;
    votes: number;
    pct: number;
}

export interface Snapshot {
    idg: string;
    generatedAt: Date | null;
    sectionsCountedPct: number;
    final: boolean;
    candidates: Record<number, CandidateResult>;
}

export const LULA = 13;
export const FLAVIO = 22;

const isPct = (v: unknown): v is number => typeof v === 'number' && Number.isFinite(v) && v >= 0 && v <= 100;
const isCount = (v: unknown): v is number => typeof v === 'number' && Number.isInteger(v) && v >= 0;

export function parseResults(json: unknown): Snapshot | null {
    if (typeof json !== 'object' || json === null) {
        return null;
    }
    const data = json as Record<string, unknown>;

    if (data.election !== '6258' || typeof data.idg !== 'string' || !isPct(data.sectionsCountedPct) || !Array.isArray(data.candidates)) {
        return null;
    }

    const candidates: Record<number, CandidateResult> = {};
    for (const c of data.candidates as Array<Record<string, unknown>>) {
        if (!c || (c.number !== LULA && c.number !== FLAVIO) || !isCount(c.votes) || !isPct(c.pct)) {
            return null;
        }
        candidates[c.number] = { number: c.number, votes: c.votes, pct: c.pct };
    }
    if (!candidates[LULA] || !candidates[FLAVIO]) {
        return null;
    }

    const generatedAt = typeof data.generatedAt === 'string' ? new Date(data.generatedAt) : null;

    return {
        idg: data.idg,
        generatedAt: generatedAt && !Number.isNaN(generatedAt.getTime()) ? generatedAt : null,
        sectionsCountedPct: data.sectionsCountedPct,
        final: data.final === true,
        candidates,
    };
}
